"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var LoadingSpinner = function LoadingSpinner(props) {
  var className = (0, _classnames.default)('pf-loader', props.className);
  var styles = props.loadingImage ? {
    backgroundImage: "url(".concat(props.loadingImage, ")")
  } : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pf-loader__image",
    style: styles,
    alt: "loading",
    "data-testid": "loading-spinner"
  }));
};
LoadingSpinner.propTypes = {
  className: _propTypes.default.string,
  loadingImage: _propTypes.default.string
};
var _default = LoadingSpinner;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');